<app-template-number [disabled]="disabled" [characters]="characters" [value]="value" [min]="min" [max]="max" [control]="control" [label]="label" />
